<template>
  <div class="card-form">
    <PageMain
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditPage="openEditPage"
      @checkbox-change="(r) => (checkRows = r)"
      @printer="({ fabricCode }) => labelPrint(fabricCode)"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      >
        <template slot-scope="{ form }">
          <b-button
            v-if="allow('A')"
            size="sm"
            class="ml-2"
            variant="outline-success"
            @click="openEditPage({ pageType: 'add' })"
          >
            <b-icon-plus></b-icon-plus>
            {{ $l('INDEX.btn_add') || '新增' }}
          </b-button>
          <b-button
            v-if="allow('MS')"
            class="ml-2"
            size="sm"
            variant="outline-success"
            @click="changeAgent"
            :disabled="!checkedCount"
          >
            {{ $l('form_label_salesman_adjustment') || '业务人员调整' }}
          </b-button>
          <b-button
            v-if="allow('P')"
            size="sm"
            class="ml-2"
            variant="outline-success"
            @click="labelPrint()"
            :disabled="!checkedCount"
          >
            <b-icon-tag></b-icon-tag>
            {{ $l('INDEX.btn_print_tag') || '标签打印' }}
          </b-button>
          <el-badge :value="checkedCount || $l('INDEX.tips_all') || '全部'">
            <b-button
              v-if="allow('E')"
              class="ml-2"
              size="sm"
              variant="outline-success"
              @click="exportFile(form)"
            >
              <i class="el-icon-download"></i>
              {{ $l('INDEX.btn_export') || '导出' }}
            </b-button>
          </el-badge>
        </template>
      </PageHeader>
      <pagination
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>

    <ChangeAgent
      :visible.sync="changeAgentOpts.visible"
      :fabricCodeList="changeAgentOpts.fabricCodeList"
      @reload="changeAgentReload"
    />
  </div>
</template>
<script>
import PageHeader from './header.vue'
import PageMain from './main.vue'
import ChangeAgent from '../change-agent'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [BaseTable, EditLoading],
  components: { PageHeader, PageMain, ChangeAgent },
  data() {
    return {
      usePage: true,
      checkRows: [],
      changeAgentOpts: { visible: false, fabricCodeList: [] },
    }
  },
  computed: {
    checkedCount() {
      return this.checkRows?.length || 0
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .masterFabric_list({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'master-fabric-detail',
        params: { ...params, pageType },
        query,
      })
    },
    changeAgent() {
      if (!this.checkedCount) return
      const fabricCodeList = this.checkRows.map((item) => item.fabricCode)
      this.changeAgentOpts = { visible: true, fabricCodeList }
    },
    changeAgentReload() {
      this.reload()
      this.$refs.main.clearCheckboxRow()
    },
    labelPrint(code) {
      const listCode = this.checkRows.map((item) => item.fabricCode)
      const codeList = code ? [code] : listCode

      if (!codeList?.length) {
        this.$message({
          showClose: true,
          message:
            this.$l('tips_warning_choose_labelPrint') || '请选择需要打印的标签',
          type: 'warning',
        })
        return
      }

      this.$api.globalExportData(
        '/digitalCenter/masterFabric/print',
        { codeList },
        '面料标签'
      )
      setTimeout(() => {
        this.$refs.main.clearCheckboxRow()
      }, 0)
    },
    exportFile(form) {
      const fabricCodeList = this.checkRows.map((item) => item.fabricCode)
      const params = { ...form, fabricCodeList }
      this.$api.globalExportData(
        '/digitalCenter/masterFabric/excel',
        params,
        '面料信息导出'
      )
      setTimeout(() => {
        this.$refs.main.clearCheckboxRow()
      }, 0)
    },
  },
}
</script>
